import type { RouteObject } from 'react-router';
import { handle } from '@/app/router/handle';

/** /permits/* */
export const permitsRoutes: RouteObject = {
  path: 'my-permits',
  handle: handle('myPermitsLicenses'),
  lazy: () =>
    import('./MyPermitsLicensesPage').then((module) => ({
      Component: module.MyPermitsLicensesPage,
    })),
};
